import { useEffect } from 'react'

import { getCurrentUser } from 'conversations/modules/user/selectors'
import { useSelector } from 'react-redux'

export default function useSetElectronUserId() {
  const currentUser = useSelector(getCurrentUser)
  useEffect(() => {
    if (window.Bridge?.setUserId && currentUser?.id) {
      window.Bridge?.setUserId(currentUser.id)
    }
  }, [currentUser?.id])
}
